import { render } from "./EditRoleClientView.vue?vue&type=template&id=080d48f2"
import script from "./EditRoleClientView.vue?vue&type=script&lang=js"
export * from "./EditRoleClientView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__